import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';
import { AuthService } from '@service/auth.service';

@Component({
    selector: 'app-sign-out',
    templateUrl: './sign-out.component.html',
    styleUrls: ['./sign-out.component.scss'],
    standalone: false
})
export class SignOutComponent {
    visible: boolean = false;
    signOutSubscription: Subscription;

    @Output() signInEmitter = new EventEmitter();
    @ViewChild('signOutContainer') signOutContainer: ElementRef;

    constructor(authService: AuthService) {
        this.signOutSubscription = authService.showSignOut$.subscribe((result) => {
            this.visible = result;
        });
    }

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (!this.signOutContainer?.nativeElement.contains(event.target) && this.visible) {
            this.onClose()
        }
    }

    onClose() {
        this.visible = false;
    }

    onLogin() {
        this.visible = false;
        this.signInEmitter.emit();
    }
}
